import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScheduledAction } from '../../../shared/interfaces/account.interfaces';
import { mapScheduledActionToLocal, mapScheduledActionToUtc } from '../../helpers/date-timezone.helper';

const basePath = '/account/scheduled_actions';

@Injectable({
  providedIn: 'root',
})

export class AccountScheduledActionsService {
  constructor(private http: HttpClient) { }

  // Get scheduled actions for an account
  getScheduledActions(accountId: number): Observable<ScheduledAction[]> {
    return this.http.get<ScheduledAction[]>(`${basePath}/${accountId}`).pipe(
      map(actions => actions.map(mapScheduledActionToLocal))
    );
  }

  // Get a scheduled action by account and ID
  getScheduledActionById(accountId: number, actionId: number): Observable<ScheduledAction> {
    return this.http.get<ScheduledAction>(`${basePath}/${accountId}/${actionId}`).pipe(
      map(mapScheduledActionToLocal)
    );
  }

  // Edit a scheduled action
  updateScheduledAction(action: ScheduledAction): Observable<ScheduledAction> {
    const utcAction = mapScheduledActionToUtc(action);
    return this.http.put<ScheduledAction>(`${basePath}/${action.account_id}/${action.id}`, utcAction).pipe(
      map(mapScheduledActionToLocal)
    );
  }

  // Create a new scheduled action
  createScheduledAction(action: ScheduledAction): Observable<ScheduledAction> {
    const utcAction = mapScheduledActionToUtc(action);
    return this.http.post<ScheduledAction>(`${basePath}`, utcAction).pipe(
      map(mapScheduledActionToLocal)
    );
  }

  // Delete a scheduled action
  deleteScheduledAction(accountId: number, actionId: number): Observable<void> {
    return this.http.delete<void>(`${basePath}/${accountId}/${actionId}`);
  }
}

